module.exports = __webpack_public_path__ + "img/boardIcon.28bb0e64.svg";